module.exports = __webpack_public_path__ + "img/process-payments.4838fca4.gif";